import angular from 'angular';

let fbLoading = {
  template: require('./fb-loading.html'),
  bindings: {
    value: '<'
  }
}

export default angular.module('components.fb-loading', [])
  .component('fbLoading', fbLoading)
  .name;



// WEBPACK FOOTER //
// ./project/components/fb-loading/index.js